export const UNAUTHENTICATED_VIEW = 'UNAUTHENTICATED_VIEW';
export const AUTHENTICATED_VIEW = 'AUTHENTICATED_VIEW';
export const RESULTS_VIEW = 'RESULTS_VIEW';
export const DETAILS_VIEW = 'DETAILS_VIEW';
export const COMPARISON_VIEW = 'COMPARISON_VIEW';
export const LOADING_VIEW = 'LOADING_VIEW';
export const EPON_ADDRESS = 'EPON_ADDRESS';
export const FDX_DISCLAIMER = 'DISCLAIMER';
